/** Geçici olarak mağaza sayfalarını kapatır. Tekrar açmak için true yapın. */
export const STORE_ENABLED = false;
